import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import _ from 'lodash';
import { Icon } from 'semantic-ui-react';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const Step = ({ onStepClick, completed = false, stepItem, index, activeStep, prevStepCompleted, elmId = 'default', viewMode, isLastStep = false, ...rest }) => {
    const isClickable = useMemo(() => onStepClick &&
        index !== activeStep &&
        (completed || prevStepCompleted || viewMode), [onStepClick, completed, index, viewMode, prevStepCompleted]);
    return (_jsxs("div", { className: cx('step-container'), "data-elm-id": `step_container_${elmId}`, children: [!isLastStep && (_jsx("div", { className: cx('connector-container'), "data-elm-id": `connector_container_${elmId}`, children: _jsx("span", { className: (index === activeStep && prevStepCompleted) || completed
                        ? cx('connector-line', 'active')
                        : cx('connector-line') }) })), _jsx("button", { "data-elm-id": `step_button_${elmId}`, onClick: isClickable
                    ? e => onStepClick(e, {
                        completed,
                        stepItem,
                        activeStep: index,
                        ...rest,
                    })
                    : _.noop, className: cx('step-button', { clickable: isClickable }), children: _jsxs("span", { className: cx('content-container'), "data-elm-id": `content_container_${elmId}`, children: [_jsx("span", { className: cx('icon-container'), "data-elm-id": `icon_container_${elmId}`, children: completed ? (_jsx(Icon, { circular: true, size: 'large', name: 'check', className: cx('checked', { active: activeStep === index }) })) : (_jsx(Icon, { size: 'large', circular: true, className: cx({ active: activeStep === index }), children: _jsx("span", { className: cx('icon-text'), children: index + 1 }) })) }), _jsx("span", { className: cx('title-container'), "data-elm-id": `title_container_${elmId}`, children: _jsx("span", { "data-elm-id": `title_${elmId}`, className: activeStep === index ? cx('title', 'active') : cx('title'), children: stepItem }) })] }) })] }));
};
Step.propTypes = {
    onStepClick: PropTypes.func,
    stepItem: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    elmId: PropTypes.string.isRequired,
    prevStepCompleted: PropTypes.bool,
    activeStep: PropTypes.number,
    completed: PropTypes.bool,
    viewMode: PropTypes.bool,
    isLastStep: PropTypes.bool,
};
const Stepper = ({ activeStep = 0, steps, className, onStepClick, elmId, viewMode = false, size = 'medium', }) => {
    return (_jsx("div", { className: cx('default', className), "data-elm-id": `wrapper_container_${elmId}`, children: _jsx("div", { className: cx('stepper-container', size), "data-elm-id": `stepper_container_${elmId}`, children: steps.map(({ elmId, stepItem, completed, ...rest }, index) => (_jsx(Step, { elmId: elmId, stepItem: stepItem, activeStep: activeStep, onStepClick: onStepClick, completed: completed, index: index, prevStepCompleted: index > 0 && steps[index - 1].completed, viewMode: viewMode, isLastStep: index === steps.length - 1, ...rest }, stepItem))) }) }));
};
export default Stepper;
Stepper.propTypes = {
    steps: PropTypes.arrayOf(PropTypes.object).isRequired,
    onStepClick: PropTypes.func,
    elmId: PropTypes.string.isRequired,
    activeStep: PropTypes.number,
    className: PropTypes.string,
    viewMode: PropTypes.bool,
    size: PropTypes.string,
};
//# sourceMappingURL=index.js.map